export default {"src":"/_next/static/media/icon-hotels.8f0935e3.svg","height":29,"width":21,"blurWidth":0,"blurHeight":0};